import * as CONSTANTS from '../../shared/constants';

const { GRID_SIZE } = CONSTANTS;

// Cache for loaded images
const upgradeImages = {};
const imageLoadPromises = {};

// Function to load an upgrade image
const loadUpgradeImage = (type) => {
  if (upgradeImages[type]) {
    return Promise.resolve(upgradeImages[type]);
  }
  
  if (imageLoadPromises[type]) {
    return imageLoadPromises[type];
  }
  
  const imagePaths = {
    'bomb': '/sprites/upgrade-bomb.svg',
    'explosion': '/sprites/upgrade-flame.svg',
    'speed': '/sprites/upgrade-skate.svg',
    'kick': '/sprites/item-kick.svg',
    'spooge': '/sprites/item-spooge.svg',
    'hand': '/sprites/upgrade-hand.svg',
    'jelly': '/sprites/upgrade-jelly.svg',
    'disease': '/sprites/upgrade-skull.svg'
  };
  
  const imagePath = imagePaths[type];
  if (!imagePath) return Promise.reject('Unknown upgrade type');
  
  imageLoadPromises[type] = new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      upgradeImages[type] = img;
      resolve(img);
    };
    img.onerror = reject;
    img.src = imagePath;
  });
  
  return imageLoadPromises[type];
};

// Pre-load all upgrade images
['bomb', 'explosion', 'speed', 'kick', 'spooge', 'hand', 'jelly', 'disease'].forEach(type => loadUpgradeImage(type));

export const renderUpgrades = (ctx, upgrades) => {
  // Render upgrades
  upgrades.forEach(upgrade => {
    const upgradeX = upgrade.x * GRID_SIZE;
    const upgradeY = upgrade.y * GRID_SIZE;
    
    if (upgrade.melting) {
      // Render melting upgrade with flickering effect
      const opacity = 0.3 + Math.sin(Date.now() * 0.01) * 0.2;
      
      // Draw the upgrade image with opacity if available
      const img = upgradeImages[upgrade.type];
      if (img) {
        ctx.save();
        ctx.globalAlpha = opacity;
        ctx.drawImage(img, upgradeX, upgradeY, GRID_SIZE, GRID_SIZE);
        
        // Add orange glow overlay for melting effect
        ctx.fillStyle = `rgba(255, 140, 0, ${opacity * 0.5})`;
        ctx.fillRect(upgradeX, upgradeY, GRID_SIZE, GRID_SIZE);
        ctx.restore();
      }
    } else {
      // Normal upgrade rendering - just draw the SVG at full size
      const img = upgradeImages[upgrade.type];
      if (img) {
        ctx.drawImage(img, upgradeX, upgradeY, GRID_SIZE, GRID_SIZE);
      } else {
        // Fallback to simple colored box if image not loaded
        ctx.fillStyle = '#ffffff';
        ctx.fillRect(upgradeX, upgradeY, GRID_SIZE, GRID_SIZE);
        ctx.strokeStyle = '#000000';
        ctx.lineWidth = 2;
        ctx.strokeRect(upgradeX, upgradeY, GRID_SIZE, GRID_SIZE);
        
        ctx.font = '24px Arial';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        
        switch (upgrade.type) {
          case 'explosion':
            ctx.fillStyle = '#ff4444';
            ctx.fillText('F', upgradeX + GRID_SIZE / 2, upgradeY + GRID_SIZE / 2);
            break;
          case 'bomb':
            ctx.fillStyle = '#444444';
            ctx.fillText('B', upgradeX + GRID_SIZE / 2, upgradeY + GRID_SIZE / 2);
            break;
          case 'speed':
            ctx.fillStyle = '#44ff44';
            ctx.fillText('S', upgradeX + GRID_SIZE / 2, upgradeY + GRID_SIZE / 2);
            break;
          case 'kick':
            ctx.fillStyle = '#ffaa00';
            ctx.fillText('K', upgradeX + GRID_SIZE / 2, upgradeY + GRID_SIZE / 2);
            break;
          case 'spooge':
            ctx.fillStyle = '#9900ff';
            ctx.fillText('SP', upgradeX + GRID_SIZE / 2, upgradeY + GRID_SIZE / 2);
            break;
          case 'hand':
            ctx.fillStyle = '#ff00ff';
            ctx.fillText('H', upgradeX + GRID_SIZE / 2, upgradeY + GRID_SIZE / 2);
            break;
          case 'jelly':
            ctx.fillStyle = '#00ff88';
            ctx.fillText('J', upgradeX + GRID_SIZE / 2, upgradeY + GRID_SIZE / 2);
            break;
          case 'disease':
            ctx.fillStyle = '#8b0000';
            ctx.fillText('D', upgradeX + GRID_SIZE / 2, upgradeY + GRID_SIZE / 2);
            break;
          default:
            break;
        }
      }
    }
  });
};